import { render, staticRenderFns } from "./MbGame.vue?vue&type=template&id=7263da02&scoped=true&"
import script from "./MbGame.vue?vue&type=script&lang=js&"
export * from "./MbGame.vue?vue&type=script&lang=js&"
import style0 from "./MbGame.vue?vue&type=style&index=0&id=7263da02&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7263da02",
  null
  
)

export default component.exports